import React, { useState } from 'react';
import ConfirmationModal from '../components/ConfirmationModal';
import i18n from '../i18n/translate';

const useConfirmAction = params => {
  const { action, children = i18n.t('Are you sure?'), disabled, ...props } = params;
  const [isConfirming, setIsConfirming] = useState(false);
  const [tempArgs, setTempArgs] = useState(null);

  const onAction = (...args) => {
    if (disabled) {
      triggerAction(args);
    } else if (!isConfirming) {
      setIsConfirming(true);
      setTempArgs(args);
    }
  }

  const onConfirm = (_, e) => {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    triggerAction(tempArgs);
    onCancel();
  }

  const onCancel = (e) => {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsConfirming(false);
    setTempArgs(null);
  }

  const triggerAction = (args) => {
    if (!action.hasOwnProperty('prototype')) {
      // cannot use spread operator so just try calling action with the first 5 array arguments (doubt we'd ever have more)
      action(args[0], args[1], args[2], args[3], args[4]);
    } else {
      // we can use the spread operator
      action(...args);
    }
  }

  const confirmationModal = disabled ?
    null :
    (
      <ConfirmationModal
        {...props}
        children={children}
        onConfirm={onConfirm}
        onCancel={onCancel}
        show={isConfirming}
      />
    );

  return {
    action: onAction,
    confirmationModal
  };
};

export default useConfirmAction;
